export function parityPlusGetter(node: {
  data: { parityPlus: boolean };
}): string[] {
  const parityPlusForDeal: string = node.data.parityPlus ? 'Yes' : 'No';
  
  return [parityPlusForDeal];
}
